require('./_wks-define')('observable');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/es7.symbol.observable.js
 ** module id = 492
 ** module chunks = 0
 **/